import { Container, Stack, Typography } from "@mui/material";
import AuthContainer from "../AuthContainer.js";
import BackButton from "../BackButton/index.js";
import Label from "../Label/index.js";
import CodeInput from "./../codeInput/index";
import GlobalButton from "../CustomButton/index.js";
import AppLoader from "../AppLoader/index.js";
import { t } from "i18next";

const styleResendBtn = {
  width: "auto",
  height: 30,
  fontSize: "0.875rem",
  fontWeight: 400,
  borderRadius: 1.5,
  border: "none",
  color: "#D45151",
  marginLeft: "240px",
  marginTop: 1,
};

const VerificationPage = ({
  handleBack,
  code,
  setCode,
  handleClickBtn,
  isLoading,
  handleSendCode,
}) => {
  return (
    <>
      <AppLoader isVisible={isLoading} />
      <AuthContainer>
        <BackButton handleBack={handleBack} />
        <Container
          sx={{
            mt: 4,
            maxWidth: "520px !important",
            height: 450,

            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Stack textAlign={"center"}>
            <Typography
              variant="auth_primary_text"
              component={"h1"}
              textTransform="capitalize"
            >
              {t("verificationProcess")}
            </Typography>
            <Typography variant="auth_secondary_text" component={"p"}>
              {t("enterVerificationCode", { codeNumber: 6 })}
            </Typography>
          </Stack>
          <Stack alignItems={"center"}>
            <Label
              labelText={`6 ${t("digitCode")}`}
              required
              labelProps={{
                marginLeft: "-230px",
              }}
            />
            <CodeInput code={code} setCode={setCode} />
            <Typography variant="heading_sec" mt={2}>
              {t("didntReceiveCode")}?{" "}
              <Typography
                component={"span"}
                color="primary"
                onClick={handleSendCode}
                sx={{
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {t("resend")}
              </Typography>
            </Typography>
            {/* <GlobalButton
            variant={"outlined"}
            btnText={`${23} Resend`}
            hoverProperties={{
              border: "none",
            }}
            styleProps={styleResendBtn}
          /> */}
          </Stack>
          <GlobalButton
            btnText={"verify"}
            handleClickBtn={handleClickBtn}
            styleProps={{
              height: 45,
            }}
          />
        </Container>
      </AuthContainer>
    </>
  );
};

export default VerificationPage;
